module.exports = __webpack_public_path__ + "02_mustache_brown.86486808.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/02_mustache_brown.png
// module id = 6Oxg
// module chunks = 0